import HttpClient from '@/store/http-client';

export default function(
  baseUrl = null,
  usePresentationSkus = false,
) {
  const client = new HttpClient(baseUrl);
  const productOptionsPath = usePresentationSkus
    ? "/shop/availability/multiProductOptions"
    : "/availability/multiProductOptions";

  return {
    availabilityOptions: {
      get: (siteSlug, skus, zipCode, startDate, endDate, variationId, success, error) => {
        const baseParams = `zip=${zipCode}&startDate=${startDate}&endDate=${endDate}`;
        const baseWithSkuParams = skus.reduce(
          (params, sku) => {
            return `${params}&sku=${sku}`
          },
          baseParams
        );
        const params = !!variationId
          ? `${baseWithSkuParams}&variationId=${variationId}`
          : baseWithSkuParams;

        client.get(
          `/site/${siteSlug}${productOptionsPath}?${params}`,
          success,
          error
        );
      }
    }
  }
}